"use client";

import { MultiStepForm } from './components/MultiStepForm';
import { octetPayEnquireFormConfig } from './OctetPayEnquireFormConfig';

export const OctetPayEnquireForm = () => {
  return (
    <MultiStepForm 
      config={octetPayEnquireFormConfig}
      className="octet-pay-form"
    />
  );
} 